import { defineComponent as _defineComponent } from 'vue'
import { computed, nextTick, onMounted, ref, watch, withDefaults } from 'vue';

type Props = {
    tabs?: any[];
    disabledTabs?: any[];
    tabbarClass?: string;
    value?: any;
    focusTab?: any;
    loading?: boolean;
}
type Emits = {
    (e: 'input:focus', event: Event | null): void;
    (e: 'input', tab: any): void;
    (e: 'tabchanged', tab: any): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Tabs',
  props: {
    tabs: { default: () => [] },
    disabledTabs: { default: () => [] },
    tabbarClass: { default: '' },
    value: { default: null },
    focusTab: { default: null },
    loading: { type: Boolean, default: false }
  },
  emits: ["input:focus", "input", "tabchanged"],
  setup(__props: any, { emit: emits }: { emit: ({
    (e: 'input:focus', event: Event | null): void;
    (e: 'input', tab: any): void;
    (e: 'tabchanged', tab: any): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { tabs: any[], disabledTabs: any[], tabbarClass: string, value: any, focusTab: any, loading: boolean };





const tabs = ref<HTMLDivElement[] | null>(null);
const tabbar = ref<HTMLDivElement | null>(null);
const activeTab = ref<any|null>(null);
const showLeftScrollIndicator = ref(false);
const showRightScrollIndicator = ref(false);

const selectedIndex = computed<number>(() => props.tabs.findIndex((tab) => tab === activeTab.value));

function showScrollIndicators() {
    if (!tabbar.value) {
        return;
    }
    const buffer = 2;
    const scrollStart = tabbar.value.scrollLeft;
    const scrollEnd = scrollStart + tabbar.value.offsetWidth + buffer;
    showLeftScrollIndicator.value = scrollStart > buffer;
    showRightScrollIndicator.value = scrollEnd < tabbar.value.scrollWidth;
}

function onResize() {
    showScrollIndicators();
    const index = props.tabs.findIndex((tab) => tab === activeTab.value);
    if (index === -1) return;
    scrollToVisible(index);
}

function onValueChanged() {
    activeTab.value = props.value;
    nextTick(() => scrollToVisible(selectedIndex.value));
}

function isDisabled(tab: any) {
    return props.disabledTabs.includes(tab);
}

function selectTab(index: number) {
    if (activeTab.value === props.tabs[index]) return;

    activeTab.value = props.tabs[index];
    emits('input', activeTab.value);
    emits('tabchanged', activeTab.value);
    scrollToVisible(index);
}

function selectPrevious() {
    if (selectedIndex.value > 0) {
        selectTab(selectedIndex.value - 1);
    }
}

function selectNext() {
    if (selectedIndex.value < props.tabs.length - 1) {
        selectTab(selectedIndex.value + 1);
    }
}

function back() {
    emits('input:focus', null);
}

function scrollToVisible(index: number): void {
    if (!tabbar.value || !tabs.value || tabs.value.length === 0) return;

    const tab = tabs.value[index];
    if (!tab) return;
    const tabStart = tab.offsetLeft - tabbar.value.offsetLeft;
    const scrollWidth = tabbar.value.getBoundingClientRect().width;
    tabbar.value.scroll({ behavior: 'smooth', left: tabStart - scrollWidth / 2 });
}

watch([() => props.tabs, () => props.disabledTabs], showScrollIndicators, { deep: true });
watch(() => props.value, onValueChanged, { deep: true });

onMounted(() => {
    activeTab.value = props.value;
    if (activeTab.value) {
        scrollToVisible(selectedIndex.value);
    }
    showScrollIndicators();
    setTimeout(() => showScrollIndicators(), 10);
    scrollToVisible(selectedIndex.value);
    window.addEventListener('resize', onResize, { passive: true });
});

return { __sfc: true,props, emits, tabs, tabbar, activeTab, showLeftScrollIndicator, showRightScrollIndicator, selectedIndex, showScrollIndicators, onResize, onValueChanged, isDisabled, selectTab, selectPrevious, selectNext, back, scrollToVisible }
}

})